import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="gradient-bg">
      <div className="gradients-container">
        <div
          className="bubble"
          style={{
            width: '150px',
            height: '150px',
            left: '30%',
            top: '40%',
            background: 'radial-gradient(circle, rgba(var(--color2), 0.8) 0%, rgba(var(--color2), 0) 50%)'
          }}
        />
        <div
          className="bubble"
          style={{
            width: '200px',
            height: '200px',
            left: '50%',
            top: '60%',
            background: 'radial-gradient(circle, rgba(var(--color3), 0.8) 0%, rgba(var(--color3), 0) 50%)'
          }}
        />
        <div
          className="bubble"
          style={{
            width: '180px',
            height: '180px',
            left: '70%',
            top: '20%',
            background: 'radial-gradient(circle, rgba(var(--color4), 0.8) 0%, rgba(var(--color4), 0) 50%)'
          }}
        />
        <div
          className="bubble"
          style={{
            width: '130px',
            height: '130px',
            left: '20%',
            top: '70%',
            background: 'radial-gradient(circle, rgba(var(--color5), 0.8) 0%, rgba(var(--color5), 0) 50%)'
          }}
        />
        {/* Add more bubbles for better visibility */}
        <div
          className="bubble"
          style={{
            width: '220px',
            height: '220px',
            left: '40%',
            top: '30%',
            background: 'radial-gradient(circle, rgba(var(--color1), 0.8) 0%, rgba(var(--color1), 0) 50%)',
            animationDelay: '2s'
          }}
        />
        <div
          className="bubble"
          style={{
            width: '170px',
            height: '170px',
            left: '60%',
            top: '40%',
            background: 'radial-gradient(circle, rgba(var(--color4), 0.8) 0%, rgba(var(--color4), 0) 50%)',
            animationDelay: '4s'
          }}
        />
      </div>
    </div>
  );
};

export default AnimatedBackground;